<template>
  <div v-if="errors">
    <v-alert type="error" dense outlined>
      <ul v-if="Array.isArray(errors)">
        <li v-for="(value, key) in errors" :key="key">{{ value }}</li>
      </ul>
      <span v-else>{{ errors }}</span>
    </v-alert>
  </div>
</template>

<script>
export default {
  name: 'BaseError',
  props: {
    errors: {
      type: [Array, String]
    }
  },
  data() {
    return {
      isError: false,
      message: null
    }
  }
}
</script>
